export type BFS_FREQUENCY_AGE_Type = {
  gender: string
  agegroup: string
  daily: number
  threetosix: number
  onetotwo: number
  lesthanone: number
  abstinent: number
  [key: string]: string | number
}
export const BFS_FREQUENCY_AGE: BFS_FREQUENCY_AGE_Type[] = [
  {
    gender: 'm',
    agegroup: 'age_15_24',
    daily: 1.7,
    threetosix: 11,
    onetotwo: 37,
    lesthanone: 29.2,
    abstinent: 21.1
  },
  {
    gender: 'm',
    agegroup: 'age_25_34',
    daily: 4.2,
    threetosix: 18.2,
    onetotwo: 45.8,
    lesthanone: 20.6,
    abstinent: 11.1
  },
  {
    gender: 'm',
    agegroup: 'age_35_44',
    daily: 7.8,
    threetosix: 22.5,
    onetotwo: 38.1,
    lesthanone: 19.7,
    abstinent: 11.8
  },
  {
    gender: 'm',
    agegroup: 'age_45_54',
    daily: 13.2,
    threetosix: 21.2,
    onetotwo: 36,
    lesthanone: 18.6,
    abstinent: 11.1
  },
  {
    gender: 'm',
    agegroup: 'age_55_64',
    daily: 19.7,
    threetosix: 20.9,
    onetotwo: 31.3,
    lesthanone: 15,
    abstinent: 13.2
  },
  {
    gender: 'm',
    agegroup: 'age_65_74',
    daily: 34.4,
    threetosix: 21,
    onetotwo: 23.1,
    lesthanone: 11.2,
    abstinent: 10.3
  },
  {
    gender: 'm',
    agegroup: 'age_75',
    daily: 40.8,
    threetosix: 12.4,
    onetotwo: 20.1,
    lesthanone: 14.3,
    abstinent: 12.3
  },
  {
    gender: 'f',
    agegroup: 'age_15_24',
    daily: 1.1,
    threetosix: 3.7,
    onetotwo: 34.3,
    lesthanone: 33.1,
    abstinent: 27.8
  },
  {
    gender: 'f',
    agegroup: 'age_25_34',
    daily: 1.8,
    threetosix: 10,
    onetotwo: 35.7,
    lesthanone: 30.1,
    abstinent: 22.3
  },
  {
    gender: 'f',
    agegroup: 'age_35_44',
    daily: 2.3,
    threetosix: 10.5,
    onetotwo: 33.4,
    lesthanone: 28.7,
    abstinent: 25.2
  },
  {
    gender: 'f',
    agegroup: 'age_45_54',
    daily: 6.1,
    threetosix: 13.2,
    onetotwo: 33.8,
    lesthanone: 26.8,
    abstinent: 20
  },
  {
    gender: 'f',
    agegroup: 'age_55_64',
    daily: 8.5,
    threetosix: 14.1,
    onetotwo: 33.5,
    lesthanone: 23.5,
    abstinent: 20.4
  },
  {
    gender: 'f',
    agegroup: 'age_65_74',
    daily: 15.7,
    threetosix: 13.4,
    onetotwo: 24.5,
    lesthanone: 24.9,
    abstinent: 21.4
  },
  {
    gender: 'f',
    agegroup: 'age_75',
    daily: 19.5,
    threetosix: 7.4,
    onetotwo: 21,
    lesthanone: 23.9,
    abstinent: 28.2
  }
]
